import { RankingHeader, RankingRequest } from '@features/rankings/models/ranking.model'
import { ComparableMetric, ListedMetric } from '@core/models/metric.models'
import { TeamComparisonHolder } from '@pages/team/models/team.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parseTeamComparisonToRankingRequest = (
  context: TeamComparisonHolder,
  value: ListedMetric | ComparableMetric,
  mode: Aggregation
): RankingRequest => ({
  seasonId: context.teamA.seasonId,
  competitionId: context.teamA.competitionId,
  metricName: value.key,
  teams: [context.teamA.id, context.teamB.id],
  aggregationDataSource: mode
})

export const parseTeamComparisonRankingHeader = (
  metricKey: string,
  metricContext: TeamComparisonHolder,
  matchDay: number
): RankingHeader => ({
  title: metricKey,
  imageA: metricContext.logoTeamA,
  textA: metricContext.nameTeamA,
  imageB: metricContext.logoTeamB,
  textB: metricContext.nameTeamB,
  placeholderA: PLACEHOLDER_IMAGES.TEAM,
  placeholderB: PLACEHOLDER_IMAGES.TEAM,
  matchDay
})
